import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-initialPoint",
  "use": "icon-initialPoint-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-initialPoint\"><path d=\"M516.312 736.202h-17.965V614.041H375.826v-17.965h140.486v140.126z\" /><path d=\"M357.861 223.124h35.93v440.14h-35.93zm90.903 495.113h433.672v35.93H448.764zm-285.283 0h139.767v35.93H163.48z\" /><path d=\"M375.826 826.386a90.902 90.902 0 1191.262-90.184 90.543 90.543 0 01-91.262 90.184zm0-145.516a54.973 54.973 0 1055.332 55.332 54.973 54.973 0 00-55.332-53.535z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol